import { render, staticRenderFns } from "./UpdateCustomerStatusModal.vue?vue&type=template&id=d99d2a7c"
import script from "./UpdateCustomerStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports